function round(num, nearest) {
  if (nearest < 1) {
    const decimals = 1 / nearest;

    return Math.round(num * decimals) / decimals;
  }
  return Math.round(num / nearest) * nearest;
}

function floor(num, nearest) {
  if (nearest < 1) {
    const decimals = 1 / nearest;

    return Math.floor(num * decimals) / decimals;
  }
  return Math.floor(num / nearest) * nearest;
}

function ceil(num, nearest) {
  if (nearest < 1) {
    const decimals = 1 / nearest;

    return Math.ceil(num * decimals) / decimals;
  }

  return Math.ceil(num / nearest) * nearest;
}

export { round, floor, ceil };
